export default {
  noResources: 'You dont have any courts here...',
  booking: 'Booking',
  noBooking: 'None'
}